import { ActiveTab, Dialog, SingleAction } from "@saleor/types";
import { stringify } from "qs";

export const ProductLensTypeSection = "/productLensType/";
export const ProductLensTypeListPath = ProductLensTypeSection;

export type ProductLensTypeListUrlDialog = "create" | "update" | "delete";

export type ProductLensTypeListUrlQueryParams = ActiveTab &
  SingleAction &
  Dialog<ProductLensTypeListUrlDialog>;

export enum ProductLensTypeListSortField {
  name = "name"
}

export const ProductLensTypeListUrl = (
  params?: ProductLensTypeListUrlQueryParams
) => ProductLensTypeListPath + "?" + stringify(params);
